import { render, staticRenderFns } from "./shoppingCart.vue?vue&type=template&id=395e88a7&"
import script from "./shoppingCart.vue?vue&type=script&lang=js&"
export * from "./shoppingCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports